import { render, staticRenderFns } from "./mslMsg.vue?vue&type=template&id=101a6e3a&scoped=true"
import script from "./mslMsg.vue?vue&type=script&lang=js"
export * from "./mslMsg.vue?vue&type=script&lang=js"
import style0 from "./mslMsg.vue?vue&type=style&index=0&id=101a6e3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a6e3a",
  null
  
)

export default component.exports